import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types'; 
import { Translate } from '../../../services';

import './styles.less';
import { CaretLeftFilled, CaretRightFilled } from '@ant-design/icons';
import classNames from 'classnames';

export const PaginationController = ( { className, itemCount, pageSize, onChange, getController, initialPage } ) => {
    const [ activePage, setActivePage ] = useState( initialPage ?? 0 );
    
    // The total number of pages.
    const pageCount = useMemo( () => {

        if ( pageSize > 0 && itemCount > 0 ) {
            return Math.ceil( itemCount / pageSize );
        }

        // If a page size and total item count aren't valid, return only
        // one page for the page count.
        return 1;
    }, [ itemCount, pageSize ] );

    const handlePageChange = ( index ) => {
        onChange && onChange( index, pageCount );
    };

    const handlePageNext = () => {
        if ( activePage < pageCount - 1 ) {
            const nextPageIndex = activePage + 1;
            setActivePage( nextPageIndex );
            handlePageChange( nextPageIndex );
        }
    };

    const handlePagePrevious = () => {
        if ( activePage > 0 ) {
            const nextPageIndex = activePage - 1;
            setActivePage( nextPageIndex );
            handlePageChange( nextPageIndex );
        }
    };

    const controller = useMemo( () => {
        return {
            pageCount: pageCount,
            activePage: activePage,
            setActivePage: ( pageIndex ) => {
                if ( pageIndex < pageCount && pageIndex >= 0 ) {
                    setActivePage( pageIndex );
                }
            },
        };
    }, [ pageCount, activePage ] );

    useEffect( () => {
        if ( getController ) {
            getController( controller );
        }
    }, [ getController, controller ] );

    return (
        <span className={ classNames( 'pagination-controller', className ) }>
            <CaretLeftFilled 
                className={ classNames( 'page-left', activePage <= 0 ? 'inactive' : 'active' ) }
                onClick={ handlePagePrevious } />
            <span className={ classNames( 'label', 'primary' ) }>
                <Translate.Text
                    value="courseList.pagination.label"
                    variables={ {
                        pageNum: '' + ( activePage + 1 ),
                        pageCount: '' + pageCount,
                    } }
                />
            </span>
            <CaretRightFilled 
                className={ classNames( 'page-right', activePage >= pageCount - 1 ? 'inactive' : 'active' ) }
                onClick={ handlePageNext } />
        </span>
    );
};

PaginationController.defaultProps = {
    className: '',
    pageSize: 0,
    itemCount: 0,
};

PaginationController.propTypes = {
    className: PropTypes.string,
    itemCount: PropTypes.number,
    pageSize: PropTypes.number,
    onChange: PropTypes.func,
    getController: PropTypes.func,
};
